import clsx from 'clsx';
import { IconProps } from '.';
import { useIconStyle } from 'components/commons';

function ErrorIcon({ className = '', style }: IconProps) {
  const classes = useIconStyle();

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(classes.root, {
        [className]: className.length > 0,
      })}
      style={style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 8C16 3.58086 12.4191 0 8 0C3.58086 0 0 3.58086 0 8C0 9.35923 0.3395 10.6697 0.978477 11.8362C1.47079 12.7345 2.1296 13.5302 2.91644 14.1772C4.33778 15.3485 6.1193 16 8 16C12.4191 16 16 12.4191 16 8ZM1 8C1 4.13314 4.13314 1 8 1C11.8669 1 15 4.13314 15 8C15 11.8669 11.8669 15 8 15C6.3535 15 4.79626 14.4305 3.55198 13.4051C2.8633 12.8389 2.28653 12.1422 1.85547 11.3557C1.29673 10.3356 1 9.19029 1 8ZM7.29289 8L4.72945 10.5634C4.53418 10.7587 4.53418 11.0753 4.72945 11.2706C4.92471 11.4658 5.24129 11.4658 5.43655 11.2706L8 8.70711L10.5634 11.2706C10.7587 11.4658 11.0753 11.4658 11.2706 11.2706C11.4658 11.0753 11.4658 10.7587 11.2706 10.5634L8.70711 8L11.2706 5.43655C11.4658 5.24129 11.4658 4.92471 11.2706 4.72945C11.0753 4.53418 10.7587 4.53418 10.5634 4.72945L8 7.29289L5.43655 4.72945C5.24129 4.53418 4.92471 4.53418 4.72945 4.72945C4.53418 4.92471 4.53418 5.24129 4.72945 5.43655L7.29289 8Z'
        fill='#3FA110'
      />
    </svg>
  );
}

export default ErrorIcon;
